// import _ from 'lodash'
import vm from '../main'
import { httpClient as http } from '../services'

const internals = {}

internals.addTrip = function (trip) {
  trip = (({
    driverId,
    deviceId,
    vehicleId,
    _id,
    routeName,
    scheduleDate,
    returnTrip,
    routeId,
    status,
    startSite,
    endSite,
    regionManager,
    scheduleTime,
    journeyManager,
    subTrips
  }) => {
    return {
      driverId,
      deviceId,
      vehicleId,
      _id,
      routeName,
      scheduleDate,
      returnTrip,
      routeId,
      status,
      startSite,
      endSite,
      regionManager,
      scheduleTime,
      journeyManager,
      subTrips
    }
  })(trip)

  return vm.$tripDataRepository
    .create(trip)
    .then(result => {
      trip = result.data
      return trip
    })
    .catch(error => {
      console.error('tripService.createTrip-error:\n', error)
      throw error
    })
}

internals.updateTrip = function (trip) {
  console.log('trip at sercibchj', trip)
  trip = Object.assign({}, trip)

  trip = (({
    driverId,
    deviceId,
    vehicleId,
    _id,
    routeName,
    scheduleDate,
    originReachedAt,
    startDate,
    destinationReachedAt,
    returnTrip,
    routeId,
    status,
    startSite,
    endSite,
    regionManager,
    scheduleTime,
    journeyManager,
    endDate
  }) => {
    return {
      driverId,
      deviceId,
      vehicleId,
      _id,
      routeName,
      scheduleDate,
      returnTrip,
      routeId,
      status,
      startSite,
      endSite,
      regionManager,
      scheduleTime,
      journeyManager,
      endDate,
      originReachedAt,
      startDate,
      destinationReachedAt
    }
  })(trip)

  return vm.$tripDataRepository
    .update(trip._id, trip)
    .then(result => {
      trip = result.data
      return trip
    })
    .catch(error => {
      console.error('tripUpdate.update-error:\n', error)
      throw error
    })
}


internals.tripGroupAdd = trip => {
  return http
    .post(`v1/createTripGroup`, trip)
    .then(response => {
      return response
    })
    .catch(error => {
      console.error('authService.login-error:\n', error)
      throw error
    })
}

internals.tripGroupDelete = trip => {
  return http
    .delete(`v1/deleteTripgroup?groupTripId=${trip}`)
    .then(response => {
      return response
    })
    .catch(error => {
      console.error('authService.login-error:\n', error)
      throw error
    })
}

internals.tripGroupDriverDetails = trip => {
  return http
    .get(`v1/group/trip/drivers?tripId=${trip}`)
    .then(response => {
      return response
    })
    .catch(error => {
      console.error('authService.login-error:\n', error)
      throw error
    })
}

export default internals



// WEBPACK FOOTER //
// ./src/services/trip.service.js